var path = './file-browser/onActionBarEditDisabledTooltip.html';
var html = "<div ng-bind-html=\"getEditDisabledReason(selectedItems[0].item)? getEditDisabledReason(selectedItems[0].item): ('FILE_ACTIONS.EDIT'| translate)\" ng-click=\"markCompanionAsInstalled()\"></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;